module.exports = __webpack_public_path__ + "static/media/sk.fadc5d7a.svg";